<template>
  <ElAlert effect="dark" show-icon type="warning">
    <div slot="title">
      {{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_TITLE') }}
      <RouterLink
        v-if="!isOnCampaignFinanceRoute"
        :to="{ name: 'search-ads-campaign-finance' }"
      >
        {{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_ACTION') }}
      </RouterLink>
    </div>
    <i18n path="ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_DESCRIPTION">
      <RouterLink :to="{ name: 'finance-transactions' }">
        {{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.ADD_BUDGET_HINT_WALLET') }}
      </RouterLink>
    </i18n>
  </ElAlert>
</template>

<script>
export default {
  name: 'CampaignViewAddBudgetHint',
  computed: {
    isOnCampaignFinanceRoute() {
      return this.$route.name === 'search-ads-campaign-finance';
    },
  },
};
</script>
